export const formatAddressObjectFullAddress = (
  address,
  displayFullAddress = false
) => {
  if (!address || typeof address !== "object") return "N/A";

  // Prefer the already-built fullAddress when explicitly requested
  if (displayFullAddress && address.fullAddress) {
    return address.fullAddress;
  }

  const { streetNumber, streetName, unit, city, state, zip } = address;

  const streetLine = [streetNumber, streetName].filter(Boolean).join(" ");

  const unitPart = unit ? `, ${unit}` : "";

  const cityStateZip = [city, state, zip].filter(Boolean).join(" ");

  const formatted = [`${streetLine}${unitPart}`.trim(), cityStateZip]
    .filter(Boolean)
    .join(", ")
    .trim();

  return formatted || "N/A";
};
